module.exports = __webpack_public_path__ + "static/media/edit.811a6820.svg";